import { render, staticRenderFns } from "./MinhaEmpresaTabEmpresas.vue?vue&type=template&id=28bf39f0&"
import script from "./MinhaEmpresaTabEmpresas.vue?vue&type=script&lang=js&"
export * from "./MinhaEmpresaTabEmpresas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports